module.exports = __webpack_public_path__ + "static/BookingBurial8bitcopy-008a9d82871161d5fddd7123196fbbb1.png";